import React, {useEffect, useState} from 'react';

import {List} from 'components/list/List';
import {Spinner} from 'components/spinner';
import {loadMetadata, selectMetadata} from 'entities/metadata';
import {TEntityValue} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectUserInfo} from 'store/slices/auth-slice';

import '../tooltip-list/tooltip-list.less';

interface ITooltipListProps {
    entityName?: string;
}

export const CurrentUserInfoTooltip = ({entityName = ''}: ITooltipListProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useAppDispatch();
    const listMeta = useAppSelector(state => selectMetadata(entityName, EEntityType.LIST)(state));
    const currentUser = useAppSelector(selectUserInfo);

    useEffect(() => {
        (async () => {
            if (!listMeta) {
                setIsLoading(true);
                await dispatch(loadMetadata(entityName, EEntityType.LIST));
                setIsLoading(false);
            }
        })();
    }, []);

    return (
        isLoading ? <Spinner /> : (
            <div className="tooltip-list">
                <List
                    listData={{data: currentUser as unknown as Record<string, TEntityValue>, id: 'currentUser'}}
                    meta={listMeta}
                    showTitle={false}
                />
            </div>
        )
    );
};
